import { forwardRef, useImperativeHandle, useState } from "react";

import "./stylesUserDeletionModal.css";

import BlockUserIcon from "../../../../../assets/icons/ic_block-user.svg";

import { CloseOutlined } from "@ant-design/icons";

import { Input, message, Select } from "antd";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import RebetLoader from "../../../../../components/CommonComponents/RebetLoader/RebetLoader";

const UserDeletionModal = forwardRef(({ handleCancel, userData }, ref) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const [step, setStep] = useState(0);
  const [isApiRunning, setIsApiRunning] = useState(false);

  const [formData, setFormData] = useState({
    reason: "",
  });

  const handleFieldChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const onCancel = () => {
    setStep(0);
    handleCancel();
  };

  const clearFormData = () => {
    setFormData({
      reason: "",
    });
    setIsApiRunning(false);
    setStep(0);
  };

  useImperativeHandle(ref, () => ({
    clearFormData,
  }));

  const onSave = async () => {
    setIsApiRunning(true);
    const params = {
      username: userData?.username,
      reason: formData.reason,
    };

    try {
      const response = await PrivateAdminPanelInstance?.delete(
        API_ROUTES?.DELETE_USER?.replace("{user_name}", params?.username),
        params
      );

      setIsApiRunning(false);

      // Show success notification
      message.success(response?.data?.message || "User deleted successfully!");
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message || "Failed to delete user";

      // Show error notification
      message.error(errorMsg);
    } finally {
      setIsApiRunning(false);
      handleCancel();
    }
  };

  return (
    <div className="user-deletion-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <img src={BlockUserIcon} alt="Block User" />
          <h2 className="modal-title"> {AppStrings.USER_DELETION}</h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        {step === 0 && (
          <>
            <p className="modal-content-title">
              {AppStrings.DO_YOU_REALLY_WANT_TO_DELETE_THIS_USER}
            </p>
          </>
        )}
        {step === 1 && (
          <>
            <div className="divider" />
            <div className="transaction-info-item">
              <Input.TextArea
                type="text"
                value={formData.reason}
                maxLength={255}
                rows={3}
                onChange={(e) => handleFieldChange("reason", e.target.value)}
              />
              <span className="max-length">{formData.reason.length}/255</span>
            </div>
          </>
        )}
      </div>

      <div className="divider" />
      <div className="modal-footer">
        {step === 0 && (
          <div className="buttons">
            <button className="cancel-button" onClick={onCancel}>
              {AppStrings.NO}
            </button>
            <button
              className="save-button"
              onClick={() => {
                setStep(1);
              }}
            >
              {AppStrings.YES}
            </button>
          </div>
        )}
        {step === 1 && (
          <div className="buttons">
            <button
              className="cancel-button"
              onClick={onCancel}
              disabled={isApiRunning}
            >
              {AppStrings.CLOSE}
            </button>
            <button
              className="save-button"
              onClick={onSave}
              disabled={isApiRunning}
            >
              {isApiRunning ? (
                <RebetLoader height={"20px"} width={"20px"} />
              ) : (
                AppStrings.SAVE
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
});

export default UserDeletionModal;
